import React, { useState, useMemo } from "react";
import PageLoader from "../components/ui/PageLoader";
import "../assets/css/style.css";
import Modal from "../components/ui/Modal";
import { useGetUserActivityQuery } from "apis/user";
import UserActivityView from "components/user/UserActivityView";
import Table from "components/ui/Table";

const UserActivity = () => {
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const pageSize = 10;

  const {
    data,
    isPending: isDataPending,
    isError: isDataError,
    error: dataError,
  } = useGetUserActivityQuery();

  const columns = useMemo(
    () => [
      {
        accessorKey: "index",
        header: "#",
        cell: (_, rowIndex, currentPage) =>
          (currentPage - 1) * pageSize + rowIndex + 1,
        isFilter: false,
        isSortable: false,
      },
      {
        accessorKey: "user.name",
        header: "User Name",
        cell: (row) => <span>{row.user?.name}</span>,
        isFilter: true,
        minWidth: "200px",
      },
      {
        accessorKey: "user.email",
        header: "Email",
        cell: (row) => <span>{row.user?.email}</span>,
        isFilter: true,
      },
      {
        accessorKey: "priceProcessCount",
        header: "Price Processes",
        cell: (row) => (
          <span className="text-center font-medium ">
            {row.priceProcessCount || 0}
          </span>
        ),
        isFilter: false,
      },
      {
        accessorKey: "bookAppraisalCount",
        header: "Book Appraisals",
        cell: (row) => (
          <span className="text-center font-medium">
            {row.bookAppraisalCount || 0}
          </span>
        ),
        isFilter: false,
      },
      {
        accessorKey: "authScheduleCount",
        header: "Auth Schedules",
        cell: (row) => (
          <span className="text-center font-medium ">
            {row.authScheduleCount || 0}
          </span>
        ),
        isFilter: false,
      },
    ],
    []
  );

  if (isDataPending) {
    return <PageLoader />;
  }

  if (isDataError) {
    return (
      <div className="container mx-auto">
        <div className="text-center py-8">
          <p className="text-red-600">
            Error loading user activity: {dataError?.message}
          </p>
        </div>
      </div>
    );
  }

  const selectedUserActivity = data?.find((activity) => activity.user._id === selectedUserId);

  const handleViewRowClick = (row) => {
    setSelectedUserId(row.user._id);
    setIsViewOpen(true);
  };

  return (
    <>
      <Modal
        isOpen={isViewOpen}
        onClose={() => setIsViewOpen(false)}
        title="User Activity Details"
        className="max-w-4xl"
      >
        <UserActivityView userActivity={selectedUserActivity} />
      </Modal>

      <div className="container mx-auto">
        <Table
          title="User Activity"
          columns={columns}
          data={data || []}
          pageSize={pageSize}
          onRowClick={handleViewRowClick}
        />
      </div>
    </>
  );
};

export default UserActivity;